import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateInputFormat } from "../components/DateComponents";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { RadioGroup } from '@headlessui/react';
import { Actions as CREATEACCOUNTACTIONS } from '../store/actions/createAccountActions';
import Select from 'react-select';

import {format, min, max, getDay, subYears, subMonths, subDays, addDays, addWeeks, addYears, differenceInCalendarDays, differenceInMonths, differenceInYears, compareAsc} from 'date-fns';

const workingDays = [
  2, 3, 4, 5, 6
]

const getWorkingDaysInPeriod = (date1, date2, workingDays, excludeFirstDay = false) => {
  if (workingDays.length == 0){
    return 0;
  }
  const firstDate = min([date1,date2])
  const secondDate = max([date1,date2])
  const dayDifference = differenceInCalendarDays(secondDate, firstDate)
  const startDay = getDay(firstDate)
  const endDay = getDay(secondDate)
  const fullWeeks = Math.floor(dayDifference / 7)
  let daysWorked = fullWeeks * workingDays.length;
  // console.log('startDay != endDay',firstDate,startDay,endDay)
  if (startDay != endDay){
    // there are some days we need to check if they are in our range
    let referenceDay = startDay;
    while (referenceDay != endDay){
      // console.log('refDay',referenceDay,endDay)
      if (workingDays.includes(referenceDay + 1)){
        daysWorked++;
      }
      referenceDay++
      if (referenceDay == 7){
        referenceDay = 0
      }
    }
    // console.log('refDay',referenceDay,secondDate)
    // there is one more loop to go
    if (workingDays.includes(referenceDay + 1 && !excludeFirstDay)){
      daysWorked++;
    }
  }
  return daysWorked;
}
const settings = [
  { name: 'Employee decided not to go to work', label: 'employeenowork'},
  { name: 'Employer asked employee not to work', label: 'employernowork'},
]

const scenarios = [
  { name: 'Employee Quit', label: 'quit'},
  { name: 'Notice given by Employer (dismissed)', label: 'dismissed'},
]

const frequencies = [
  { value: 'Hourly', label: 'Hourly' },
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Yearly', label: 'Yearly' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function NoticePeriodCalculator({
  timeWorked,
  hourlySalary,
  leaveSalary,
  payDue,
  payDueHalf,
  weeksToAdd,
  saveLead,
  error,
  saving,
  profile
}) {

  let hoursDue = 0
  let daysDue = 0
  let endOfNoticePeriod = null

  const [doe, setDoe] = useState();
  const [noticeDate, setNoticeDate] = useState();
  const [lastDay, setLastDay] = useState();
  const [remainingLeave, setRemainingLeave] = useState(0);
  const [salary, setSalary] = useState(800);
  const [frequency, setFrequency] = useState("Monthly");
  const [scenario, setScenario] = useState(scenarios[0]);
  const [selected, setSelected] = useState(settings[0]);
  const [hrsWorked, setHrsWorked] = useState(0);
  const [showDownloadForm, setShowDownloadForm] = useState(false);

  const [data, setData] = useState({
    noOfEmployees: "1-5",
    name: "",
    surname: "",
    phone: "",
    organisation: "",
    email: "",
  });

  useEffect(() => {
    if (profile) {
        setData({
            ...data,
            name: profile.givenName || profile.name,
            surname: profile.familyName || profile.surname,
            email: profile.email,
        })
    }
  }, [profile]);

  useEffect(() => {
    setLastDay(noticeDate);
  }, [noticeDate]);

  const handleChange = (event) => {
      setData({
          ...data,
          [event.target.name]: event.target.value
      })
  }

  const submitForm = () => {
      saveLead({ ...data, list: 5 })
      // send email

  }

  const handleClick = () => {
    setShowDownloadForm(!showDownloadForm)
  }

  if(doe && noticeDate) {

    timeWorked = {
      years: differenceInYears(noticeDate, doe),
      months: differenceInMonths(noticeDate, doe),
    }

    if(timeWorked.months == 0) {
      endOfNoticePeriod = noticeDate
    } else if(timeWorked.months >= 1 && timeWorked.months < 6) {
      weeksToAdd = 1
      endOfNoticePeriod = addWeeks(noticeDate, weeksToAdd)
    } else if(timeWorked.months >= 6 && timeWorked.years < 2) {
      weeksToAdd = 2
      endOfNoticePeriod = addWeeks(noticeDate, weeksToAdd)
    } else if(timeWorked.years >= 2 && timeWorked.years < 4) {
      weeksToAdd = 4
      endOfNoticePeriod = addWeeks(noticeDate, weeksToAdd)
    } else if(timeWorked.years >= 4 && timeWorked.years < 7) {
      weeksToAdd = 8
      endOfNoticePeriod = addWeeks(noticeDate, weeksToAdd)
    } else if(timeWorked.years >= 7) {
      weeksToAdd = (12 < (8+(timeWorked.years-7)) ? 12 : (8+(timeWorked.years-7)))
      endOfNoticePeriod = addWeeks(noticeDate, weeksToAdd)
    }
  }

  if(doe && noticeDate && lastDay){
    // last day is not in the unpaid period
    daysDue = getWorkingDaysInPeriod(lastDay, endOfNoticePeriod, workingDays, true)
    hoursDue = daysDue*8
  }

  if(endOfNoticePeriod && salary) {
    switch(frequency) {
      case 'Hourly':
        if(differenceInMonths(lastDay, new Date(doe)) >= 3) {
          const date = new Date();
          hourlySalary = salary * (hrsWorked/(getWorkingDaysInPeriod(subMonths(date, 3), date, workingDays)*8))
        } else { hourlySalary = salary }
      break;
      case 'Daily':
        hourlySalary = salary / 8
      break;
      case 'Weekly':
        hourlySalary = salary / 8 / 5
      break;
      case 'Monthly':
        hourlySalary = salary * 12 / 2080
      break;
      case 'Yearly':
        hourlySalary = salary / 2080
      break;
    }
  }

  payDue = ((hourlySalary * hoursDue)).toFixed(2)
  payDueHalf = (hourlySalary * hoursDue/2).toFixed(2)
  leaveSalary = (hourlySalary * remainingLeave).toFixed(2)

  return (
    <div className="grid grid-cols-12 gap-5 lg:gap-1">
      <div className="mx-4 sm:text-center md:max-w-2xl md:mx-auto col-span-12 lg:col-span-5 lg:text-left lg:flex items-start">

        <div className="px-4 py-5 bg-gray-100 space-y-4 sm:p-6 rounded-md">
          <form action="#" method="POST">
            <div className="shadow rounded-md">
              <div className="rounded-md px-4 py-5 bg-white sm:p-6">
                <div className="grid grid-cols-6 gap-6 items-end">
                  <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700">
                      Date of Employment
                    </label>
                      <DatePicker
                          popperClassName="z-50"
                          wrapperClassName="w-full"
                          className="shadow-sm block pl-2 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent w-full"
                          selected={doe}
                          minDate={subYears(new Date(), 100)}
                          maxDate={noticeDate && lastDay && compareAsc(noticeDate, lastDay) == 1 ? subDays(lastDay, 1) : subDays(noticeDate, 1)}
                          onChange={(date) => setDoe(date)}
                          dateFormat="dd/MM/yyyy"
                          customInput={<DateInputFormat />}
                      />
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700">
                      Date Notice Handed In
                    </label>
                      <DatePicker
                          popperClassName="z-50"
                          wrapperClassName="w-full"
                          className="shadow-sm block pl-2 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent w-full"
                          selected={noticeDate}
                          minDate={doe}
                          onChange={(date) => {setNoticeDate(date)}}
                          dateFormat="dd/MM/yyyy"
                          customInput={<DateInputFormat />}
                      />
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label className="block text-sm font-medium text-gray-700">
                      Last Day of Work
                    </label>
                      <DatePicker
                          popperClassName="z-50"
                          wrapperClassName="w-full"
                          className="shadow-sm block pl-2 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent w-full"
                          selected={lastDay}
                          minDate={noticeDate || doe}
                          maxDate={noticeDate ? new Date(endOfNoticePeriod) : null}
                          onChange={(date) => setLastDay(date)}
                          dateFormat="dd/MM/yyyy"
                          customInput={<DateInputFormat />}
                      />
                  </div>
                  <div className="col-span-6 sm:col-span-3">
                    <label htmlFor="remainingLeave" className="block text-sm font-medium text-gray-700">
                      Remaining leave balance
                    </label>
                    <div className="relative rounded-md shadow-sm">
                      <input
                        type="number"
                        id="remainingLeave"
                        name="remainingLeave"
                        onChange={(e) => setRemainingLeave(e.target.value)}
                        className="block w-full pl-3 pr-14 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent focus:z-10 focus:ring-orange-400 focus:border-orange-400"
                        placeholder="0"
                      />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <span className="text-gray-500 sm:text-sm">Hours</span>
                      </div>
                    </div>
                  </div>
                  <div className={(differenceInMonths(lastDay, new Date(doe)) >= 3) && frequency == 'Hourly' ? "col-span-6 sm:col-span-3" : "col-start-2 col-end-6"}>
                    <label htmlFor="salary" className="ml-1 block text-sm font-medium text-gray-700">
                    Gross Salary
                    </label>
                    <div className="relative rounded-md shadow-sm w-full">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">€</span>
                        </div>
                        <input
                        type="number"
                        id="salary"
                        name="salary"
                        defaultValue="800"
                        selected={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        className="w-full pl-7 pr-24 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent focus:z-10 focus:ring-orange-400 focus:border-orange-400"
                        placeholder="0.00"
                        />
                        <div className="absolute inset-y-0 right-1 flex items-center z-20" style={{ width:"5.15rem" }}>
                        <Select
                          styles={{control: base => ({ ...base, border:0, boxShadow: "none"})}}
                          components={{
                            IndicatorSeparator: () => null
                          }}
                          className="w-full text-sm"
                          defaultValue={frequencies[3]}
                          name="frequency"
                          selected={frequencies.find(f => f.label == frequency)}
                          onChange={(val) => setFrequency(val.label)}
                          options={frequencies}
                        />
                      </div>
                      </div>
                  </div>
                  {(differenceInMonths(lastDay, new Date(doe)) >= 3) && frequency == 'Hourly' &&
                  <div className="col-span-6 sm:col-span-3">
                    <label htmlFor="hoursWorked" className="block text-sm font-medium text-gray-700">
                      Hours worked in last 3 mo.
                    </label>
                    <div className="relative rounded-md shadow-sm">
                      <input
                        type="number"
                        name="hoursWorked"
                        id="hoursWorked"
                        value={hrsWorked}
                        onChange={(e) => setHrsWorked(e.target.value)}
                        className="block w-full pl-3 pr-14 sm:text-sm border-gray-300 rounded-md h-10 border border-transparent focus:z-10 focus:ring-orange-400 focus:border-orange-400"
                        placeholder="0"
                      />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <span className="text-gray-500 sm:text-sm">Hours</span>
                      </div>
                    </div>
                  </div>}
                </div>
              </div>
            </div>
          </form>

          <div className="mt-5 md:mt-0 md:col-span-2">
            <form action="#" method="POST">
              <div className="shadow rounded-md">
                <RadioGroup value={scenario} onChange={setScenario}>
                  <div className="bg-white rounded-md -space-y-px">
                    {scenarios.map((setting, settingIdx) => (
                      <RadioGroup.Option
                        key={setting.name}
                        value={setting}
                        className={({ checked }) =>
                          classNames(
                            settingIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
                            settingIdx === scenarios.length - 1 ? 'rounded-bl-md rounded-br-md' : '',
                            checked ? 'bg-orange-50 border-orange-500 z-10' : 'border-gray-200',
                            'relative border p-4 flex cursor-pointer focus:outline-none'
                          )
                        }
                      >
                      {({ active, checked }) => (
                        <>
                          <span
                            className={classNames(
                              checked ? 'bg-orange-600 border-transparent' : 'bg-white border-gray-300',
                              active ? 'ring-2 ring-offset-2 ring-orange-500' : '',
                              'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center'
                            )}
                            aria-hidden="true"
                          >
                            <span className="rounded-full bg-white w-1.5 h-1.5" />
                          </span>
                          <div className="ml-3 flex flex-col">
                            <RadioGroup.Label
                              as="span"
                              className={classNames(checked ? 'text-orange-900' : 'text-gray-900', 'block text-sm font-medium')}
                            >
                              {setting.name}
                            </RadioGroup.Label>
                          </div>
                        </>
                      )}
                    </RadioGroup.Option>
                  ))}
                </div>
              </RadioGroup>
            </div>
          </form>
        </div>

        { ((scenario.label == 'quit' || noticeDate) && endOfNoticePeriod && lastDay && compareAsc(new Date(endOfNoticePeriod), lastDay) == 1) &&
          <div className="mt-5 md:mt-0 md:col-span-7">
            <form action="#" method="POST">
              <div className="shadow rounded-md">
                <RadioGroup value={selected} onChange={setSelected}>
                    <div className="bg-white rounded-md -space-y-px">
                      {settings.map((setting, settingIdx) => (
                        <RadioGroup.Option
                          key={setting.name}
                          value={setting}
                          className={({ checked }) =>
                            classNames(
                              settingIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
                              settingIdx === settings.length - 1 ? 'rounded-bl-md rounded-br-md' : '',
                              checked ? 'bg-orange-50 border-orange-500 z-10' : 'border-gray-200',
                              'relative border p-4 flex cursor-pointer focus:outline-none'
                            )
                          }
                        >
                        {({ active, checked }) => (
                          <>
                            <span
                              className={classNames(
                                checked ? 'bg-orange-600 border-transparent' : 'bg-white border-gray-300',
                                active ? 'ring-2 ring-offset-2 ring-orange-500' : '',
                                'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center'
                              )}
                              aria-hidden="true"
                            >
                              <span className="rounded-full bg-white w-1.5 h-1.5" />
                            </span>
                            <div className="ml-3 flex flex-col">
                              <RadioGroup.Label
                                as="span"
                                className={classNames(checked ? 'text-orange-900' : 'text-gray-900', 'block text-sm font-medium')}
                              >
                                {setting.name}
                              </RadioGroup.Label>
                            </div>
                          </>
                        )}
                      </RadioGroup.Option>
                    ))}
                  </div>
                </RadioGroup>
              </div>
            </form>
          </div>
          }
        </div>
      </div>
      { selected && doe && salary && noticeDate &&
      <div className="mx-4 mt-5 md:mt-0 col-span-12 lg:col-span-6">
        <div className="bg-gray-100 space-y-4 p-6 rounded-md">
            <div className="shadow overflow-hidden rounded-md">
              <div className="px-4 py-5 bg-white sm:p-6">
                <label className="block text-sm font-medium text-gray-700 prose">

                  {/* Dismissal date */}
                  <p>The Termination Notice was handed on {format(noticeDate, "dd/MM/yyyy")} by the {scenario.label == 'quit' ? "employee" : "employer"}.</p>
                  
                  <p>The last day of work as per the notice period calculation should be {format(endOfNoticePeriod, "dd/MM/yyyy")}.</p>
                  
                  {hoursDue > 0 &&

                  // Hours worked
                  <p>As your actual last day of work is {format(lastDay, "dd/MM/yyyy")}, <strong>{daysDue} more day{daysDue > 1 ? 's': ''}</strong> had to be worked as per your notice period, ending on {format(endOfNoticePeriod, "dd/MM/yyyy")}.

                    {/* Employee owes/employer owes start*/}
                    { scenario.label == 'quit' && selected.label == 'employeenowork' &&
                      " Because of this, you owe your employer a sum of half the wage that would be payable in this period"
                    }

                    { scenario.label == 'dismissed' && selected.label == 'employeenowork' &&
                      " Since you didn't work the notice period, your employer owes you a sum of half the wage that would be payable in this period"
                    }

                    { selected.label == 'employernowork' &&
                      " Since your employer asked you to not work any further, they owe you a sum of your full wage that would be payable in this period"
                    }

                    {(payDue != 'NaN' && payDue != 'Infinity') &&
                     <span>, amounting to €{selected.label == 'employeenowork' ? payDueHalf : payDue}<label className="text-sm font-medium text-red-500">*</label></span>}
                    .
                  </p>}

                  {/* Employee owes/employer owes end*/}
                  
                  {/* Leave balance start */}

                  { (remainingLeave > 0) ? 
                    <p>You have {remainingLeave} hour{remainingLeave != 1 ? "s" : ""} of leave remaining. This balance amounts to €{leaveSalary}

                      { scenario.label == 'quit' && selected.label == 'employeenowork' &&
                        <span>{hoursDue > 0 ? ` and may be deducted from the above value in order to pay your employer less.` : "."}</span>
                      }

                      { (scenario.label == 'dismissed' || selected.label == 'employernowork') && 
                        <span> This balance is to be paid to you by the employer, totalling to €{leaveSalary}<label className="text-sm font-medium text-red-500">*</label>.</span>
                      }
                    </p>
                    : ""
                  }

                  {/* Leave balance end */}

                </label>
                { (payDue > 0 || payDueHalf > 0 || ((scenario.label == 'dismissed' || selected.label == 'employernowork') && leaveSalary > 0)) &&
                <div>
                  <br />
                  <label className="block text-xs font-medium text-red-500">*This calculation is made assuming a 40-hour, Monday to Friday work week, consisting of 8-hour shifts. Actual results may vary.</label><br />
                  <a target="_blank" rel="noreferrer" href="https://dier.gov.mt/en/Employment-Conditions/Termination%20of%20Employment/Pages/Compensation-in-Lieu-of-Notice.aspx" className="block text-xs font-medium text-blue-700 hover:underline">Source</a>
                </div>}
              </div>
            </div>
            <div className="shadow overflow-hidden rounded-md">
              <div className="grid items-center gap-2">
                { false && !showDownloadForm &&
                  <button
                    className="py-2 h-full border border-transparent leading-5 font-medium rounded-md text-white bg-orange-500 transition duration-150 ease-in-out w-full"
                    onClick={() => handleClick()}
                  >
                    Download Employer Report
                  </button>
                }
                {showDownloadForm &&
                  <>

                    {error &&
                      <div className="rounded-md bg-red-50 p-4 mb-6">
                          <div className="flex">
                              <div className="ml-3">
                                  <h3 className="text-sm leading-5 font-medium text-red-800">
                                      Error: {error}
                                  </h3>
                              </div>
                          </div>
                      </div>
                    }

                    <div className="grid grid-cols-2 gap-2 items-center">
                        <div>
                            <label htmlFor="name" className="sr-only">
                                Name
                            </label>
                            <div className="rounded-md shadow-sm">
                                <input value={data.name} onChange={handleChange} name="name" id="name" placeholder="Name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="surname" className="sr-only">
                                Surname
                            </label>
                            <div className="rounded-md shadow-sm">
                                <input value={data.surname} onChange={handleChange} name="surname" id="surname" placeholder="Surname" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                            </div>
                        </div>
                    </div>

                    <div className="items-center">
                        <label htmlFor="organisation" className="sr-only">
                            Organisation
                        </label>
                        <div className="rounded-md shadow-sm">
                            <input value={data.organisation} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                        </div>
                    </div>

                    <div className="items-center">
                        <label htmlFor="noOfEmployees" className="sr-only">
                            No of Employees
                        </label>
                        <div className="rounded-md shadow-sm">
                            <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                                <option value="1-5">1-5 Employees</option>
                                <option value="6-10">6-10 Employees</option>
                                <option value="11-20">11-20 Employees</option>
                                <option value="21-40">21-40 Employees</option>
                                <option value="41-80">41-80 Employees</option>
                                <option value="81-200">81-200 Employees</option>
                                <option value="200+">200+ Employees</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="email" className="sr-only">
                            Email
                        </label>
                        <div className="rounded-md shadow-sm">
                            <input value={data.email} onChange={handleChange} name="email" id="email" placeholder="Email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
                        </div>
                    </div>

                    <span className="block w-full h-full rounded-md shadow-sm text-center">

                        {
                            saving &&
                            <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        }
                        {!saving &&
                            <button onClick={() => submitForm()} className="py-2 w-full h-full flex justify-center items-center px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-500 hover:bg-orange-400 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                                Send My Report
                            </button>
                        }
                    </span>
                  </>
                  }
              </div>
            </div>
        </div>
      </div>}
      {(!doe || !noticeDate || !salary) &&
      <div className="mx-4 col-span-12 lg:col-span-6">
        <div className="bg-gray-100 space-y-4 p-6 rounded-md">
            <div className="shadow overflow-hidden rounded-md">
              <div className="px-4 py-5 bg-white sm:p-6">
                <label className="block text-sm font-medium text-gray-700">
                  Please input the date of employment, date on which the notice handed in, last day of work &amp; your salary, as well as any remaining leave balance you may have.
                </label>
              </div>
            </div>
        </div>
      </div>}
    </div>
  );
}

const mapStateToProps = (state) => {
  const createAccount = state && state.createAccount
  const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))
  return {
    saving: createAccount.savingLead,
    profile,  
  }
}

const mapDispatchToProps = dispatch => ({
  saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoticePeriodCalculator)